
import { Component, Vue } from "vue-property-decorator";
import { dispatchGetTransactionsList, dispatchCheckDexfreedomTokenInfo, dispAuthFetch } from "@/store/mlm/actions";
import { readTransactionsResponse } from "@/store/mlm/getters";
import { dispatchGetAllConfigs } from "@/store/main/actions";
// import moment from "moment-timezone";
import { DateTime, Duration } from 'luxon';
import { shortenText } from "@/utils";
import UiCheckbox from "@/components/Main/Ui/UiCheckbox.vue";
import UiRadioButton from "@/components/Main/Ui/UiRadioButton.vue";
import UiCalendar from "@/components/Main/Ui/UiCalendar.vue";
import WithdrawalModal from "@/components/Main/Transactions/WithdrawalModal.vue";
import DepositModal from "@/components/Main/Transactions/DepositModal.vue";
import GiveAGiftModal from "@/components/Main/Transactions/GiveAGiftModal.vue";
import TransactionsInfoModal from "@/components/Main/Transactions/TransactionsInfoModal.vue";
import TransferTokensModal from "@/components/Main/Transactions/TransferTokensModal.vue";
import WarningModal from "@/components/Main/Transactions/WarningModal.vue";

import GeneratePrivateKeyDexIdModal from "@/components/Main/Transactions/GeneratePrivateKeyDexIdModal.vue";
import GeneratePublicKeyDexIdModal from "@/components/Main/Transactions/GeneratePublicKeyDexIdModal.vue";

import { readUserProfile } from '@/store/main/getters';

@Component({
  methods: { shortenText },
  components: {
    UiCalendar,
    UiRadioButton,
    UiCheckbox,
    GeneratePublicKeyDexIdModal,
    GeneratePrivateKeyDexIdModal,
    WithdrawalModal,
    DepositModal,
    GiveAGiftModal,
    TransactionsInfoModal,
    TransferTokensModal,
    WarningModal,
  },
})
export default class Transactions extends Vue {
  public page = 1;
  public searchCommentParams = "";
  public selectedPeriod = "";
  public selectedCurrency: string[] = ["All"];
  public selectedIntervalDay?: string = "";
  public selectedType = "";
  public selectedCommentType = "";
  public withdrawModalShow = false;
  public giftModalShow = false;
  public depositModalShow = false;
  public transactionsInfoModal = false;
  public showWarningModal = false;
  public transferTokensModalShow = false;
  public filtersModalShow = false;
  public selectedFilters: string[] = [];

  public start_date?: string = undefined;
  public end_date?: string = undefined;

  public isShowTypeBonus: boolean = true;
  public isShowCurrency: boolean = false;
  public isShowPeriod: boolean = false;
  // matching
  public isShowMatching: boolean = false;
  public isShowDexnetMatching: boolean = false;

  public isLoadingData: boolean = false;

  public dexfreedomTokenInfo: {
    success: boolean;
    amount: number;
    last_transaction_dt: Date | null;
  } = {
    success: false,
    amount: 0,
    last_transaction_dt: null,
  };

  public async mounted() {
    this.resetFilters();
    dispatchGetAllConfigs(this.$store);
    this.handleUpdateList();
    if (this.$router.currentRoute.query.top_up) {
      this.handleOpenDepositModal();
    }

    let dexfreedomTokenInfoResp = await dispatchCheckDexfreedomTokenInfo(this.$store);
    if (!dexfreedomTokenInfoResp || dexfreedomTokenInfoResp.status != 200 || dexfreedomTokenInfoResp.data == null) {
    } else {
      this.dexfreedomTokenInfo = {
        success: dexfreedomTokenInfoResp.data.success,
        amount: dexfreedomTokenInfoResp.data.amount,
        last_transaction_dt: dexfreedomTokenInfoResp.data.last_transaction_dt
          ? new Date(dexfreedomTokenInfoResp.data.last_transaction_dt)
          : null,
      };
    }
  }

  public selectedDateRange(rangeDate) {
    this.start_date = rangeDate[0] ? rangeDate[0] : undefined;
    this.end_date = rangeDate[1] ? rangeDate[1] : undefined;
  }

  public removeFilterAll() {
    if (this.selectedFilters.includes("All")) {
      this.selectedFilters.splice(this.selectedFilters.indexOf("All"), 1);
    }
  }

  public removeCurrencyFilterAll() {
    if (this.selectedCurrency.includes("All")) {
      this.selectedCurrency.splice(this.selectedCurrency.indexOf("All"), 1);
    }
  }

  public updateDexnetMatchingItems() {
    // this.isShowDexnetMatching = this.selectedFilters.includes("marketing.DexnetMatchingBonus");
    
    // Если выбран marketing.DexnetMatchingBonus, автоматически выбираем все связанные чекбоксы
    if (this.selectedFilters.includes("marketing.DexnetMatchingBonus")) {
      const relatedFilters = [
        "marketing.DexnetRewardPool",
        "marketing.DexnetSixMonthsPromo",
        "marketing.PromoBonusDexnet", 
        "marketing.DexnetYearPromoMatching",
        "marketing.DexnetBonus0825",
        "marketing.Dexnet100Promo"
      ];
      
      // Добавляем все связанные фильтры, если их еще нет
      relatedFilters.forEach(filter => {
        if (!this.selectedFilters.includes(filter)) {
          this.selectedFilters.push(filter);
        }
      });
    } else {
      // Если marketing.DexnetMatchingBonus не выбран, убираем все связанные фильтры
      this.selectedFilters = this.selectedFilters.filter(filter => 
        ![
          "marketing.DexnetRewardPool",
          "marketing.DexnetSixMonthsPromo",
          "marketing.PromoBonusDexnet",
          "marketing.DexnetYearPromoMatching", 
          "marketing.DexnetBonus0825",
          "marketing.Dexnet100Promo"
        ].includes(filter)
      );
    }
  }

  public updatePurchaseItems() {
    if (this.selectedFilters.includes("finance.PurchasePackage")) {
      this.selectedFilters.push("finance.ProductPurchase", "finance.PurchaseTokenPackage", "finance.PurchaseVirtualNode", "finance.PurchaseSigmaRing");
    } else {
      this.selectedFilters = this.selectedFilters.filter(filter => !["finance.ProductPurchase", "finance.PurchaseTokenPackage", "finance.PurchaseVirtualNode", "finance.PurchaseSigmaRing"].includes(filter));
    }
  }

  public selectFilter(type) {
    this.isShowTypeBonus = false;
    this.isShowCurrency = false;
    this.isShowPeriod = false;
    this.isShowMatching = false;

    switch (type) {
      case "isShowTypeBonus":
        this.isShowTypeBonus = true;
        break;
      case "isShowMatching":
        this.isShowMatching = true;
        break;
      case "isShowCurrency":
        this.isShowCurrency = true;
        break;
      case "isShowPeriod":
        this.isShowPeriod = true;
        break;
      default:
    }
  }

  public handleOpenWithdrawModal() {
    this.withdrawModalShow = true;
  }

  public handleCloseWithdrawModal(updated: boolean = false) {
    this.withdrawModalShow = false;
    if (updated) {
      this.handleUpdateList();
    }
  }

  public handleOpenGiftModal() {
    this.giftModalShow = true;
  }

  public handleCloseGiftModal(updated: boolean = false, action) {
    this.giftModalShow = false;
    if (updated) {
      this.handleUpdateList();
    }

    if (action == "needCash") {
      this.handleOpenDepositModal();
    }
  }

  public handleOpenDepositModal() {
    this.depositModalShow = true;
  }

  public handleCloseDepositModal() {
    this.depositModalShow = false;
    this.handleUpdateList();
  }

  public handleShowWarningModal() {
    this.showWarningModal = true;
  }

  public handleCloseWarningModal() {
    this.showWarningModal = false;
  }

  public handleChangeType(newType) {
    this.page = 1;
    this.selectedCommentType = newType;
    this.handleUpdateList();
    this.filtersModalShow = false;

    if (newType != "Bonus") this.resetFilters();
  }

  public async handleChangePage(page) {
    if (this.page !== page) {
      this.page = page;
      this.handleUpdateList();
    }
  }

  public resetFilters() {
    this.selectedFilters = ["All"];
    this.selectedCurrency = ["All"];
    this.selectedIntervalDay = undefined;
    this.start_date = "2024-01-01";
    this.end_date = "2024-12-31";
    this.isShowDexnetMatching = false;
    this.isShowMatching = false;
  }

  public async handleUpdateList(page = "") {
    //
    /* not understand
    if (this.selectedFilters.includes("marketing.MatchingBonus")) {
      this.selectedFilters.push("marketing.DexnetMatchingBonus", "marketing.Dexnet100Promo");
    } else {
      this.selectedFilters = this.selectedFilters.filter(f =>
          !["marketing.DexnetMatchingBonus", "marketing.Dexnet100Promo"].includes(f)
      );
    }

    if (this.selectedFilters.includes("marketing.DexnetRewardPool")) {
      this.selectedFilters.push("marketing.DexnetSixMonthsPromo", "marketing.PromoBonusDexnet", "marketing.DexnetYearPromoMatching");
    } else {
      this.selectedFilters = this.selectedFilters.filter(f =>
          !["marketing.DexnetSixMonthsPromo", "marketing.PromoBonusDexnet", "marketing.DexnetYearPromoMatching"].includes(f)
      );
    }

    if (this.selectedFilters.includes("marketing.InviteBonusLost")) {
      this.selectedFilters.push("marketing.MatchingBonusLost", "marketing.BinaryBonusLost");
    } else {
      this.selectedFilters = this.selectedFilters.filter(f =>
          !["marketing.MatchingBonusLost", "marketing.BinaryBonusLost"].includes(f)
      );
    }
      */

    /*purchase
    if (this.selectedFilters.includes("finance.PurchasePackage")) {
      this.selectedFilters.push(
          "finance.PurchasePromocodeActivated",
          "finance.PurchasePromocode",
          "finance.ProductPurchase",
          "finance.PurchaseTokenPackage",
          "finance.PurchaseVirtualNode"
      );
    } else {
      this.selectedFilters = this.selectedFilters.filter(f =>
          ![
            "finance.PurchasePromocodeActivated",
            "finance.PurchasePromocode",
            "finance.ProductPurchase",
            "finance.PurchaseTokenPackage",
            "finance.PurchaseVirtualNode"
          ].includes(f)
      );
    }
      */

    this.isLoadingData = true;
    
    /** currency */
    if (this.selectedCommentType == "Bonus") {
      // Для валюты X отправляем сразу две метки: X и X1_B
      const preparedCurrency =
        this.selectedCurrency.includes("All") || this.selectedCurrency.length === 0
          ? undefined
          : Array.from(
              new Set(
                this.selectedCurrency.flatMap(currency =>
                  currency === "X" ? ["X", "X1_B"] : [currency]
                )
              )
            );

      await dispatchGetTransactionsList(this.$store, {
        filter: {
          currency: preparedCurrency,
          search_comment_params: this.searchCommentParams,
          comment_type: this.selectedCommentType,
          comment_template: this.selectedFilters.includes("All") ? undefined : this.selectedFilters,
          period: this.selectedIntervalDay == "Interval" ? undefined : this.selectedIntervalDay,
          start_date: this.selectedIntervalDay == "Interval" ? this.start_date : undefined,
          end_date: this.selectedIntervalDay == "Interval" ? this.end_date : undefined,
        },
        page,
      });
    } else {
      await dispatchGetTransactionsList(this.$store, {
        filter: {
          period: this.selectedPeriod,
          search_comment_params: this.searchCommentParams,
          comment_type: this.selectedCommentType,
        },
        page,
      });
    }

    this.isLoadingData = false;
  }

  get transactionsResponse() {
    return readTransactionsResponse(this.$store);
  }

  public async handleOpenTransferTokensModal() {
    this.transferTokensModalShow = true;
  }

  public toggleModalShow() {
    this.filtersModalShow = !this.filtersModalShow;
    this.selectedCommentType = "Bonus";
    this.handleUpdateList();
  }

  public handleCloseTransferTokensModal() {
    this.transferTokensModalShow = false;
    this.handleUpdateList();
  }

  get isTransferButtonActive(): boolean {
    if (this.dexfreedomTokenInfo.amount === 0) {
      return false;
    }
    // return this.durationUntilNextTransfer.asMilliseconds() <= 0;
    return this.durationUntilNextTransfer.toMillis() <= 0;
  }

  public formatNumber(num) {
    const n = Number(num);
    return n % 1 === 0 ? n.toFixed(0) : n.toFixed(4).replace(/\.?0+$/, "");
  }

  get durationUntilNextTransfer() {
  if (!this.dexfreedomTokenInfo.last_transaction_dt) {
    return Duration.fromMillis(0);
  }
  const deadline = DateTime.fromJSDate(this.dexfreedomTokenInfo.last_transaction_dt)
    .toUTC()
    .plus({ days: 31 });
  const now = DateTime.utc();
  return deadline.diff(now, ['days', 'hours', 'minutes']);
}

  // get durationUntilNextTransfer() {
  //   if (!this.dexfreedomTokenInfo.last_transaction_dt) {
  //     return moment.duration(0);
  //   }
  //   const deadline = moment.utc(this.dexfreedomTokenInfo.last_transaction_dt).add(31, "days");
  //   const now = moment.utc();
  //   return moment.duration(deadline.diff(now));
  // }

  get timeUntilTransfer() {
  const duration = this.durationUntilNextTransfer;
  return {
    days: Math.floor(duration.days),
    hours: duration.hours,
    minutes: duration.minutes,
  };
}

  // get timeUntilTransfer() {
  //   const duration = this.durationUntilNextTransfer;
  //   const days = Math.floor(duration.asDays());
  //   const hours = duration.hours();
  //   const minutes = duration.minutes();

  //   return {
  //     days: days,
  //     hours: hours,
  //     minutes: minutes,
  //   };
  // }

  get userProfile() {
    return readUserProfile(this.$store);
  }
}
